import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var userData5B = localStorage.getItem("userData5B") ? JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B")))) : "";

var serviceName = "index";
var haberService = {
    imageUrlBuyuk: WsProvider.resim + "/" + userData5B["firmaKodu"] + "/buyuk/",
    imageUrlOrta: WsProvider.resim + "/" + userData5B["firmaKodu"] + "/orta/",
    imageUrlKucuk: WsProvider.resim + "/" + userData5B["firmaKodu"] + "/kucuk/",
    imageUrlEnKucuk: WsProvider.resim + "/" + userData5B["firmaKodu"] + "/enkucuk/",
    path  : "https://www.5bmuhendislik.com.tr/",
    haberTanimlama(link, kategori, baslik, altBaslik, icerik, seoBaslik, seoIcerik, resimList,buton,butonLink,video, resimKonum, menuKonum, galeriKonum, baslamaTarihi, bitisTarihi,sayac,begen, durum) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                link: link,
                kategori: kategori,
                baslik: baslik,
                altBaslik: altBaslik,
                icerik: icerik,
                seoBaslik: seoBaslik,
                seoIcerik: seoIcerik,
                resimList: resimList,
                buton: buton,
                butonLink: butonLink,
                video: video,
                resimKonum: resimKonum,
                menuKonum: menuKonum,
                galeriKonum: galeriKonum,
                baslamaTarihi: baslamaTarihi,
                bitisTarihi: bitisTarihi,
                sayac:sayac,
                begen:begen,
                durum: durum,
                serviceName: "haber",
                methodName: "haberTanimlama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    haberDetay(haberId) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                haberId: haberId,
                serviceName: "haber",
                methodName: "haberDetay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    haberCount(durum) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                durum: durum,
                serviceName: "haber",
                methodName: "haberCount"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    haberKisaList(kategoriKodu, limit) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                kategoriKodu: kategoriKodu,
                limit: limit,
                serviceName: "haber",
                methodName: "haberKisaList"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    haberListDetay(kategoriId , baslangic, limit, durum) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                kategoriId : kategoriId ,
                baslangic: baslangic,
                limit: limit,
                durum: durum,
                serviceName: "haber",
                methodName: "haberListDetay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    haberDurumGuncelle(haberId, durum) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                haberId: haberId,
                durum: durum,
                serviceName: "haber",
                methodName: "haberDurumGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    haberGuncelle(haberId, updateList) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                haberId: haberId,
                updateList: updateList,
                serviceName: "haber",
                methodName: "haberGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

}

export default haberService

